<template>
  <div class="detail" v-if="currentTrack && uploadData" >
    <div class="detail-wrapper">
      <h3 class="detail-title">
        <br>
        <span>List of boxes containing this track</span>
        <span style="margin-left: 72%">
        <Button :empty="empty" @click.prevent="moveFiles()"  >
          <template>{{  'Link to Boxes' }}</template>
        </Button>
        </span>
      </h3>
      <hr>
      <div class="detail-row detail-row--2cols">
        <div class="wrapper" v-if="uploadData">
          <DataTable :value="uploadData.items" :size="'Large'" tableStyle="min-width: 50rem">
            <Column  header="Station" style="width: 25%">
              <template #body="slotProps">
                <span   v-text="filteredStations(slotProps.data.stationId)[0].name">  </span>
              </template>
            </Column>
            <Column  header="Box name" style="width: 25%">
              <template #body="slotProps">
                <span >
                  <i class="fas fa-box-open" :style="{ 'color': slotProps.data.colorCode}"></i>&nbsp;
                  <span v-text="slotProps.data.name" ></span>&nbsp;
                 </span>&nbsp;
<!--                  <b-badge variant="primary"  style="background: grey" pill>-->
<!--                                                  <span v-if="slotProps.data.type === Constants.boxTypes.SMARTBOX.value || Constants.boxTypes.SMARTBOX.key.localeCompare(slotProps.data.type) === 0">-->
<!--                                                      <i class="fas fa-bolt"></i>-->
<!--                                                  </span>-->
<!--                    <span v-else>-->
<!--                                                      {{slotProps.data.statistics.trackCount}}-->
<!--                                                  </span>-->
<!--                  </b-badge>-->
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <SelectorBoxes
          v-show="false"
          ref="modalBoxes"
          :stationUid="currentStationUid"
          :noModalEdit="true"
          v-on:newValue="linkToBoxes"
      />

<!--      <div class="detail-footer">-->
<!--        <div class="detail-footer-right">-->
<!--          <button class="detail-save" @click="submit">Save</button>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import SelectorBoxes from "@/components/Library/SelectorBoxes.vue";
import Constants from "@/store/constants";
import moment from "moment";
import Tag from "primevue/tag";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import {HTTP} from "@/utils/http";
export default {
  components: {DataTable, Column, Tag ,SelectorBoxes},
  ...mapActions('tracks', ["loadCountiesList"]),
  computed: {
    Constants() {
      return Constants
    },
    ...mapState({

          currentTrack: state => state.tracks.currentTrack,
          currentStationUid: state => state.currentStationUid,
    })
  },
  data() {
    return {
      uploadData:null
    }
  },
  mounted() {

    const interval =  setInterval(() => {
          if (this.currentTrack){
            this.loadData();
            clearInterval(interval)
          }
        }

        , 100);
  },

  methods: {
    filteredStations (id) {
      // console.log(uid)
      // if(uid ==='00000000-0000-0000-0000-000000000000'){
      //   return [{name:'Station undefined'}]
      // }

      // console.log(this.$store.state.stations.items , uid)
      if (this.$store.state.stations.items.length > 0) {
        return (this.$store.state.stations.items || []).filter(station => {
          console.log(station.id === id)
          return station.id === id;
        })
      }

    },
    moveFiles() {
      let files = this.currentTrack ;

      this.$refs.modalBoxes.show(files);
    },
    async linkToBoxes(type, targetBoxes)
    {
      console.log('linkToBoxes')
      console.log(type, targetBoxes)
      for(var idx in targetBoxes)
      {
        let box = targetBoxes[idx];
        console.log("Data : ",box, Object.keys(this.currentTrack), box.uid, box.stationUid);
        await this.$store.dispatch("Boxes/linkMultipleTrack",
            {
              stationUid: box.stationUid,
              boxUid: box.uid,
              trackUids:[this.currentTrack.uid ]
            })
       // await this.refreshBoxStats(box.stationUid,box.uid)
      }

    //  await this.refreshBoxStats(this.$route.params.stationUid,this.$route.params.boxUid)
    //  await this.reloadTracks();
      await this.loadData();
    },
    loadData(){
      console.log('------------------------------------' , this.currentTrack)
      if(this.currentTrack){


      HTTP.get('Api/boxes/list/', {
        params: {
        //  radioUid: this.$route.params.stationUid,
          trackUid: this.currentTrack.uid,
          sortField: 'name',
          sortAscending: true,
          pageSize: 1000,
          page: 0,
          isAdvanced: true
        }
      }

      )
          .then(({ data }) => {
            console.log(data)
          //  this.errorMessage = false;
            this.uploadData = data.dataItem
          })
          .catch(error => {
            this.errorMessage = true;
            console.log('-------------')
            console.log('error', error)
          })
      }
    }
  },
  watch: { }
}
</script>
<style lang="scss" scoped>
.vdp-datepicker {
  // width: 170%!important;
}
.trash {
  margin-right: 180%!important;
}
.date{
  border: hidden;
  max-width: 300px;
  border-bottom: 1px solid #ced4da;
}
.disabled_item{
  margin-left: 128px!important;
}

.label{
  font-size: 16px;
}
.detail {
  padding: 25px 25px 40px;
}

.detail-wrapper {
  display: flex;
  flex-direction: column;
  // max-width: 1040px;
}
.wrapper{
  padding: 25px 25px 40px;
  // max-width: 1000px;
}

.detail-title {
  color: #292C33;
  font-size: 16px;
  line-height: 1;

  &:not(:first-child) {
    margin-top: 40px;
  }

  + .detail-row {
    margin-top: 20px;
  }
}

.detail-row {

  &:first-child {
    margin-top: 0;
  }

  &--2cols {
    .detail-cell {
      width: 50%;
    }
  }

  &--3cols {
    .detail-cell {
      width: 33.33%;

      &--big {
        width: 66.66%;
      }
    }
  }
}

.detail-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 15px;

  &.has-error {
    .detail-error {
      display: block;
    }
  }
}

.detail-label {
  display: block;
  transition: transform .3s ease-in-out;
  color: #696B70;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: .2px;
  line-height: calc(16 / 13);

  i {
    margin-left: 5px;
    color: #ABACAF;
    font-style: italic;
  }
}

.detail-value {
  margin-top: 8px;
  display: block;
  color: #292C33;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: .2px;
  line-height: calc(17 / 14);
}

.detail-error {
  display: none;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #f00;
}

// Footer
// -----------------------------------------------------------------------------
.detail-footer {
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  position: relative;
  width: 100%;
  margin-top: 20px;
  padding-top: 25px;
  border-top: 1px solid #d2d2d2;

  button {
    text-transform: uppercase;
  }
}

.detail-footer-right {
  display: flex;
  align-items: center;
  margin-left: auto;

  .m-loader + .detail-button {
    opacity: .5;
    pointer-events: none;
  }

  .detail-button {
    margin-left: 20px;
  }
}

.detail-footer-loader {
  color: #696B70;
  font-size: 14px;
  margin-right: 10px;
}

.detail-link {
  padding: 0;
  border: 0;
  border-radius: 0;
  transition: color .2s ease-in-out;
  background-color: transparent;
  color: #ABACAF;
}

// Transitions
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

// Inputs
.field {
  color: #696B70;
  display: flex;
  flex-direction: column;
  // padding-top: 3px;
  position: relative;
  width: 100%;

  &.inline {
    height: 24px;
    padding-top: 0;
    line-height: 16px;

    .input {
      height: 24px;
    }

    input {
      font-size: 13px;
    }

  }
}

.append, .prepend {
  font-size: 13px;
}

label {
  display: block;
  font-weight: 300;
  font-size: 11px;
  transition: all .15s ease-out;
  margin-bottom: 0;

  span {
    color: #ABACAF;
    font-style: italic;
  }
}

.field.error {
  label {
    color: #FE6B5B;
  }

  .message {
    color: #FE6B5B;
  }
}

.message {
  text-align: right;
  font-size: 13px;
  line-height: 20px;
}
.pi-chevron-down{
  font-size: 15px;
}
.select {
  background: #ffffff;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  border-radius: 3px;
  width: 4.2rem !important;
  height: 2.45rem !important;
  border: hidden;
  border-bottom: 1px solid #ced4da;

  &::placeholder {
    color: #ccc;
  }
}

.focused:not(.readonly) {
  &:not(.empty) {
    label {
      color: var(--color-brand);
    }
  }
}
.has-error{
  border-color: red;
}
.error {
  color: #FE6B5B;
}
</style>
